import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const BestSellerSection = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await fetch(
          "https://tyka.premierhostings.com/backend/api/site-banner"
        );
        const data = await res.json();

        // ✅ API से आने वाले top_products को safe तरीके से set करना
        if (data?.top_products?.data) {
          setProducts(data.top_products.data);
        } else {
          console.error("No products found in API response", data);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, []);

  return (
    <section className="py-10 max-w-7xl mx-auto w-full px-4">
      {/* Heading */}
      <div className="text-center mb-8">
        <h2 className="text-2xl sm:text-3xl font-bold mb-2">
          Best Seller Products
        </h2>
        <p className="text-gray-500 max-w-2xl mx-auto text-sm sm:text-base">
          Gear up with the champions’ choice. Our best sellers bring the winning
          spirit to you.
        </p>
      </div>

      {/* Layout */}
      <div className="flex flex-col lg:flex-row gap-6 w-full">
        {/* Left Side - Carousel */}
        <div className="w-full lg:w-3/4">
          <Swiper
            modules={[Autoplay]}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            loop={true}
            spaceBetween={16}
            slidesPerView={1}
            breakpoints={{
              640: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
          >
            {products.map((product) => (
              <SwiperSlide key={product.id}>
                <div className="bg-white shadow-md overflow-hidden flex flex-col items-center">
                  {/* Image wrapped in link */}
                  <a href={`/${product.slug}`}>
                    <img
                      src={
                        product.default_image?.length > 0
                          ? `${product.default_image}`
                          : "/images/placeholder.png"
                      } // ✅ API में image field होनी चाहिए
                      alt={product.name}
                      className="w-full h-auto object-contain"
                    />
                  </a>
                  <div className="text-center mt-3 px-2 pb-4">
                    <h3 className="text-sm sm:text-base font-medium">
                      {product.name}
                    </h3>
                    <div className="mt-1">
                      {product.old_price && (
                        <span className="line-through text-gray-400 mr-2 text-sm">
                          ₹{product.old_price}
                        </span>
                      )}
                      <span className="text-base font-semibold">
                        ₹{product.price || "N/A"}
                      </span>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Right Side - Video */}
        <div className="w-full lg:w-1/4">
          <div className="relative overflow-hidden h-[100%] sm:h-[300px] lg:h-full">
            <video
              controls
              autoPlay
              muted
              loop
              controlsList="nodownload"
              playsInline
              className="w-full h-full object-cover"
            >
              <source src="/video/gravix.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BestSellerSection;
